import { render, staticRenderFns } from "./RecapTherapy.vue?vue&type=template&id=642e598f"
import script from "./RecapTherapy.vue?vue&type=script&lang=js"
export * from "./RecapTherapy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports